import {
  BackendServerActionType,
  BackendServerHookPoint,
  ButtonElementModel,
  ButtonPanelElementModel,
  CastUtility,
  ConfirmResult,
  DbCommonColumnName,
  DevelopEditViewScript,
  DevelopScriptServicePack,
  DialogViewInfo,
  EditPanelElementModel,
  EditType,
  EditTypeUtility,
  InputPartsBaseModel,
  InputRadioAndInputPartsElementModel,
  KeyUsedByItem,
  LinkElementModel,
  MessageType,
  ModelUtility,
  PanelModel,
  PanelType,
  ResponseDataModel,
  SubTicketBaseModel,
  SubTicketListPanelElementModel,
  ValidateCheckUtility,
  ViewDialogType,
  ViewType,
  displayLock,
  displayUnLock,
} from '@ktvs8/gocoo-engine-front-end';

import { MProgramUtility } from 'src/app/utility/m-program-utility';
import { ReceiptDateDialogConditionList } from '../Dialog/receipt-date-dialog-condition-list';
import ReceiptDateDialogConditionListItem from '../Dialog/receipt-date-dialog-condition-list-item.json';
/**
 * プログラム編集画面のスクリプト
 */
export class ProgramEdit implements DevelopEditViewScript {
  scriptName: string = 'ProgramEdit';

  /**
   * データ取得後にフッターボタンパネルの要素が必要なため初期処理でパネルモジュールを取得しておく。
   */
  initPanelModels: Map<PanelType, PanelModel> = new Map<PanelType, PanelModel>();

  /**
   * 初期処理
   * @param panelModels
   * @param service
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    this.setupDisabledSubTicketColumn(editPanel.subTicketListPanelElementModel);

    this.hiddenRegisterButton(panelModels);
    this.initPanelModels = panelModels;
  }
  /**
   * 終了処理
   * @param panelModels
   * @param service
   */
  destroy(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}
  /**
   * バリデーションチェック
   * @param targetValidationPanel
   * @param actionType
   * @param panelModels
   * @param service
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }
  /**
   * 検索処理終了後の処理
   * @param editPanel
   * @param service
   */
  fetchedRecord(editPanel: EditPanelElementModel, service: DevelopScriptServicePack): void {
    //権限制御
    this.setupShowEditButton(editPanel, service);
    this.setupDisabledSubTicketColumn(editPanel.subTicketListPanelElementModel);
    this.setupStatusNameStyle(editPanel);
    this.setupHideSecForOnairDatetime(editPanel);
    if (EditTypeUtility.getEditTypeInUrl() === EditType.Readonly) {
      this.setupRecreateButton(editPanel, service);
    }
  }

  /**
   * ボタン押下時の処理
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {
    if (clickedButtonElement.id === 'subTicketAddButton') {
      const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
      this.addSubTicket(editPanel, service);
    }
    // 発注書を開くを押下
    else if (clickedButtonElement.id.includes('OpenOrderSheetButton')) {
      this.showOrderSheet(panelModels, clickedButtonElement, service);
    }
    // 受領日リンクを押下
    else if (clickedButtonElement.id.includes('LinkOrderSheetButton')) {
      this.linkReceiptDate(panelModels, clickedButtonElement, service);
    }

    // 今回発注なしボタンを押下
    else if (clickedButtonElement.id.includes('ChangeSendingOrderSheetButton')) {
      this.changeSendingOrderSheet(panelModels, clickedButtonElement);
    }

    // 削除ボタンを押下
    else if (clickedButtonElement.id.includes('DeleteButton_')) {
      this.deleteOnetimeData(panelModels, service, this.getRowIndexFromButtonId(clickedButtonElement));
    }

    // 登録ボタン押下
    else if (clickedButtonElement.id === 'RegisterButton') {
      this.registerProgram(panelModels, service);
    }
    // 発注データ再作成ボタン押下
    else if (clickedButtonElement.id === 'RecreateButton') {
      this.recreateProgramOrder(panelModels, service);
    }

    // 番組マスタ遷移ボタン押下
    else if (clickedButtonElement.id === 'MoveMProgramPageButton') {
      this.moveMProgramPage(panelModels, service);
    }
  }

  /**
   * リンク押下時の処理
   * @param panelModels
   * @param clickedLinkElement
   * @param service
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ): void {}
  /**
   * 入力パーツのイベント処理
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * 登録ボタンの表示・非表示を設定する
   * @param panelModels
   */
  hiddenRegisterButton(panelModels: Map<PanelType, PanelModel>) {
    const buttonPanel = panelModels.get(PanelType.FooterButtonPanel) as ButtonPanelElementModel;

    buttonPanel.leftButtons.forEach((button: ButtonElementModel) => {
      if (button.id === 'RegisterButton') {
        button.isHidden = EditTypeUtility.getEditTypeInUrl() === EditType.Readonly;
      }
    });
  }

  /**
   * 発注データ再作成ボタンの表示・非表示を設定する
   * @param panelModels
   * @param service
   */
  setupRecreateButton(editPanel: EditPanelElementModel, service: DevelopScriptServicePack) {
    this.canEdit(editPanel, service).then((result) => {
      if (result === undefined) {
        return;
      }
      const footerButtonPanel = this.initPanelModels.get(PanelType.FooterButtonPanel) as ButtonPanelElementModel;
      footerButtonPanel.rightButtons.forEach((button) => {
        if (!button) {
          return;
        }
        button.isHidden = !result;
      });
    });
  }

  /**
   * サブチケットを追加する
   * @param editPanel
   * @param service
   */
  addSubTicket(editPanel: EditPanelElementModel, service: DevelopScriptServicePack): void {
    const subTicketListPanel = editPanel.subTicketListPanelElementModel;
    subTicketListPanel.addNewSubTicket();
    let onairDate = '';
    let mProgramTicketKey = '';
    editPanel.inputPartsList.forEach((inputParts: InputPartsBaseModel) => {
      if (inputParts.id === 'OnairDate') {
        onairDate = inputParts.value;
      }
      if (inputParts.id === 'MProgramTicketKey') {
        mProgramTicketKey = inputParts.value;
      }
    });
    const addIndex = subTicketListPanel.subTicketList.length - 1;
    const addSubTicket = subTicketListPanel.subTicketList[addIndex];

    // 入力欄の値をセット
    const setValueWithColumnName = (columnName: string, value: any, disabled: boolean = false) => {
      const column = addSubTicket.getColumnByColumnName(columnName);
      if (!column) {
        return;
      }
      column.inputParts.setValue(value);
      column.inputParts.disabled = disabled;
    };

    setValueWithColumnName('Content', '');
    setValueWithColumnName('Memo', '');
    setValueWithColumnName('ReceiptDate', '');
    setValueWithColumnName('StatusName', '', true);
    setValueWithColumnName('Status', 'OrderNotFinished', true);
    setValueWithColumnName('OrderType', 'Onetime', true);

    // その他の隠し項目を設定
    addSubTicket.hiddenKeyValue['MProgramTicketKey'] = mProgramTicketKey;
    addSubTicket.hiddenKeyValue['StopOrder'] = 'false';
    addSubTicket.hiddenKeyValue['ReceiptDateTicketLink'] = '';
    addSubTicket.hiddenKeyValue['OnairDate'] = onairDate;

    // サブチケットの各カラムの編集状態を設定
    this.setupDisabledSubTicketColumn(subTicketListPanel);
  }

  /**
   * 発注書のダイアログを表示する
   * @param panelModels
   * @param clickedButtonElement
   * @param service
   */
  async showOrderSheet(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ) {
    const newOrderSheet = () => {
      return ValidateCheckUtility.isEmpty(subTicket.hiddenKeyValue['OrderSheetTicketKey']);
    };
    const index = this.getRowIndexFromButtonId(clickedButtonElement);
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    const subTicket = editPanel.subTicketListPanelElementModel.subTicketList[index];

    const message = newOrderSheet() ? '発注書を作成しますか？' : '発注書を開きますか？';
    const result = await service.dialogService.showYesOrNoConfirmDialog(message);
    if (result !== ConfirmResult.Yes) {
      return;
    }

    // 紐づきで分岐させる
    if (newOrderSheet()) {
      service.moveViewService.moveViewInGocooEngine(ViewType.GroupEdit, 'OrderSheet', EditType.New, {
        mProgramTicketKey: subTicket.hiddenKeyValue['MProgramTicketKey'],
        mProgramOrderTicketKey: subTicket.hiddenKeyValue['MProgramOrderTicketKey'],
      });
    } else {
      service.moveViewService.moveViewInGocooEngine(ViewType.GroupEdit, 'OrderSheet', EditType.Readonly, {
        TicketKey: subTicket.hiddenKeyValue['OrderSheetTicketKey'],
      });
    }
  }

  /**
   * クリックされたサブチケットを削除する
   * @param panelModels
   * @param clickedButtonElement
   * @returns
   */
  deleteSubTicket(panelModels: Map<PanelType, PanelModel>, clickedButtonElement: ButtonElementModel) {
    if (!clickedButtonElement.id.includes('DeleteButton_')) {
      return;
    }
    const index = this.getRowIndexFromButtonId(clickedButtonElement);
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    const subTicketListPanel = editPanel.subTicketListPanelElementModel;
    subTicketListPanel.deleteSubTicket(index);
  }

  /**
   * 今回発注書書を送信しない処理
   * @param panelModels
   * @param clickedButtonElement
   * @returns
   */
  changeSendingOrderSheet(panelModels: Map<PanelType, PanelModel>, clickedButtonElement: ButtonElementModel) {
    if (!clickedButtonElement.id.includes('ChangeSendingOrderSheetButton_')) {
      return;
    }

    const index = this.getRowIndexFromButtonId(clickedButtonElement);
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    const subTicket = editPanel.subTicketListPanelElementModel.subTicketList[index];

    const orderType = subTicket.getColumnByColumnName('OrderType');
    if (orderType == undefined) {
      return;
    }

    if (orderType.inputParts.value !== 'Master' && orderType.inputParts.value !== 'Spot') {
      return;
    }

    subTicket.hiddenKeyValue['StopOrder'] = subTicket.hiddenKeyValue['StopOrder'] === 'false' ? 'true' : 'false';
    this.setupDisabledSubTicketColumn(editPanel.subTicketListPanelElementModel);
  }
  /**
   * 押下されたボタンの行番号を取得する
   * @param clickedButtonElement
   * @returns
   */
  getRowIndexFromButtonId = (clickedButtonElement: ButtonElementModel) =>
    CastUtility.anyToNumber(clickedButtonElement.id.split('_')[1]);

  /**
   * 受領日選択のリンクの紐づけ　解除処理
   * @param panelModels
   * @param clickedButtonElement
   * @param service
   * @returns
   */
  async linkReceiptDate(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ) {
    if (!clickedButtonElement.id.includes('LinkOrderSheetButton_')) {
      return;
    }
    const index = this.getRowIndexFromButtonId(clickedButtonElement);

    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    const subTicket = editPanel.subTicketListPanelElementModel.subTicketList[index];

    let receiptDateTicketLink = ModelUtility.getValueInObject(subTicket.hiddenKeyValue, 'ReceiptDateTicketLink');

    // 'remove-link-order-sheet-button'を取り除いたデフォルトのスタイルを取得
    let linkOrderSheetButton = subTicket.getColumnByColumnName('LinkOrderSheetButton');
    if (linkOrderSheetButton == undefined) {
      return;
    }
    const convertClass = linkOrderSheetButton.buttonParts.class.filter(
      (className: string) => className !== 'remove-link-order-sheet-button'
    );

    // 登録データ
    const getRegisterData = (status: string) => {
      const registerData = {
        [DbCommonColumnName.TICKET_TYPE]: subTicket.ticketInfo.ticketType,
        [DbCommonColumnName.TICKET_KEY]: subTicket.ticketInfo.ticketKey,
        Status: status,
      };
      return registerData;
    };

    const getDataForLink = (receiptDateTicketKey: string) => {
      const dataForLink = {
        TicketType: subTicket.getSubTicketTicketType(),
        TicketKey: subTicket.getSubTicketTicketKey(),
        ProgramOrderTicketKey: subTicket.getSubTicketTicketKey(),
        ReceiptDateTicketKey: receiptDateTicketKey,
        Parameter: true,
      };
      return dataForLink;
    };

    const dataForUnlink = {
      TicketType: subTicket.getSubTicketTicketType(),
      TicketKey: subTicket.getSubTicketTicketKey(),
      ProgramOrderTicketKey: subTicket.getSubTicketTicketKey(),
      Parameter: false,
    };

    const registerHookPoint = (
      data: any,
      comFirmFunction: Function,
      backendServerHookPoint: BackendServerHookPoint
    ) => {
      service.dataTransmissionService.registerRecord(
        ViewType.ConditionList,
        editPanel.getTicketKeyObject()[DbCommonColumnName.TICKET_TYPE],
        data,
        comFirmFunction,
        backendServerHookPoint,
        false
      );
    };

    let callBack: Function = new Function();
    let request: Object = Object();

    // リンクのチケット無しのときの紐づけ処理
    if (ValidateCheckUtility.isEmpty(receiptDateTicketLink) || receiptDateTicketLink === '') {
      const receiptDateTicketKey = await this.showReceiptDateDialog(subTicket, service);
      if (ValidateCheckUtility.isEmpty(receiptDateTicketKey)) {
        return;
      }
      // 受領日選択ウィンドウを閉じてからリロードまでの間に時間がかかることがあり、その間操作できないようにする
      displayLock('受領日リンク中');

      const registerData = getRegisterData('OrderFinished');
      request = Object.assign(editPanel.commonDBValue.getKeyValueForEditPanel(), registerData);
      /**
       * 紐づけ処理のときのコールバック関数
       */
      callBack = (responseData: ResponseDataModel) => {
        if (!responseData.isCompleted) {
          return;
        }

        let linkOrderSheetButton = subTicket.getColumnByColumnName('LinkOrderSheetButton');
        if (linkOrderSheetButton == undefined) {
          return;
        }
        linkOrderSheetButton.buttonParts.class = convertClass;

        const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
        this.setupDisabledSubTicketColumn(editPanel.subTicketListPanelElementModel);

        let backendServerHookPoint: BackendServerHookPoint = new BackendServerHookPoint();
        backendServerHookPoint.overrideExecuteFunctionName = 'ManualProgramAndOrdersheetLink';

        const dataForLink = getDataForLink(receiptDateTicketKey);

        /**
         * 紐づけが成功したかを確認するためのコールバック関数
         */
        const confirmLinked = async () => {
          displayUnLock();
          const condition = {
            TicketType: subTicket.getSubTicketTicketType(),
            TicketKey: subTicket.getSubTicketTicketKey(),
          };
          const record = await service.dataTransmissionService.fetchRecord(
            ViewType.Edit,
            subTicket.getSubTicketTicketType(),
            condition,
            null,
            false,
            null,
            false
          );
          if (record.data['ReceiptDateTicketLink'] === receiptDateTicketKey) {
            service.moveViewService.reload();
            return;
          } else {
            throw new Error('チケットの紐づけに失敗しました。');
          }
        };

        registerHookPoint(dataForLink, confirmLinked, backendServerHookPoint);
      };
      // リンク解除
    } else {
      const result = await service.dialogService.showYesOrNoConfirmDialog('この受領日リンクを解除しますか');
      if (result !== ConfirmResult.Yes) {
        return;
      }
      /**
       * 紐づけ解除のときのコールバック関数
       */
      // リンク解除とリロードまでの間に時間がかかることがあり、その間操作できないようにする
      displayLock('受領日リンク解除中');

      const registerData = getRegisterData('OrderNotFinished');
      request = Object.assign(editPanel.commonDBValue.getKeyValueForEditPanel(), registerData);
      callBack = (responseData: ResponseDataModel) => {
        if (!responseData.isCompleted) {
          return;
        }

        let linkOrderSheetButton = subTicket.getColumnByColumnName('LinkOrderSheetButton');
        if (linkOrderSheetButton == undefined) {
          return;
        }
        linkOrderSheetButton.buttonParts.class = convertClass;

        const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
        this.setupDisabledSubTicketColumn(editPanel.subTicketListPanelElementModel);

        let backendServerHookPoint: BackendServerHookPoint = new BackendServerHookPoint();
        backendServerHookPoint.overrideExecuteFunctionName = 'ManualProgramAndOrdersheetLink';

        /**
         * 紐づけを解除を確認するためのコールバック関数
         */
        const confirmUnlinked = async () => {
          displayUnLock();
          const condition = {
            TicketType: subTicket.getSubTicketTicketType(),
            TicketKey: subTicket.getSubTicketTicketKey(),
          };
          const record = await service.dataTransmissionService.fetchRecord(
            ViewType.Edit,
            subTicket.getSubTicketTicketType(),
            condition,
            null,
            false,
            null,
            false
          );
          if (record.data['ReceiptDateTicketLink'] === '') {
            service.moveViewService.reload();
            return;
          } else {
            throw new Error('チケットの紐づけ解除に失敗しました。');
          }
        };
        registerHookPoint(dataForUnlink, confirmUnlinked, backendServerHookPoint);
      };
    }

    // 登録処理
    service.dataTransmissionService.registerRecord(
      ViewType.Edit,
      subTicket.ticketInfo.ticketType,
      request,
      callBack,
      null,
      false
    );
  }

  /**
   * 状両備紐づけダイアログを表示
   *
   * @description
   *  - 受領日選択ダイアログを表示
   *  - 選択後に受領日を返却
   *  - 処理は非同期で行う
   *
   * @param service
   * @returns 選択した受領日のチケットキー
   */
  showReceiptDateDialog(subTicket: SubTicketBaseModel, service: DevelopScriptServicePack): Promise<string> {
    return new Promise((resolve, reject) => {
      const dialogViewInfo: DialogViewInfo = {
        dialogViewLayoutInfo: {
          width: 1200,
          height: 700,
        },
        dataType: 'ReceiptDate',
        dialogType: ViewDialogType.ConditionList,
        editType: EditType.Readonly,
        item: ReceiptDateDialogConditionListItem,
        script: new ReceiptDateDialogConditionList(),
        sendDataToDialog: subTicket.hiddenKeyValue['MProgramTicketKey'],
      };

      service.dialogService.showViewDialog(dialogViewInfo).then((ticketKey) => {
        if (ValidateCheckUtility.isEmpty(ticketKey)) {
          resolve('');
        }

        resolve(ticketKey);
      });
    });
  }

  /**
   * サブチケットの各カラムに対して編集状態を設定する
   * @param subTicketListPanel
   */
  setupDisabledSubTicketColumn(subTicketListPanel: SubTicketListPanelElementModel) {
    const setupHeaders = () => {
      /**
       * 指定したヘッダーの表示・非表示を設定する
       * @param columnName
       * @param isHidden
       */
      const isHiddenHeader = (columnName: string, isHidden: boolean) => {
        subTicketListPanel.headers.forEach((header: any) => {
          if (header.columnName === columnName) {
            header.isHidden = isHidden;
          }
        });
      };

      const caseByEdit = () => {
        isHiddenHeader('ReceiptDate', true);
        isHiddenHeader('StatusName', true);
        isHiddenHeader('OpenOrderSheetButton', true);
        isHiddenHeader('LinkOrderSheetButton', true);
        isHiddenHeader('ChangeSendingOrderSheetButton', false);
        isHiddenHeader('ReceiptDateType', false);
      };
      const caseByReadonly = () => {
        isHiddenHeader('ReceiptDate', false);
        isHiddenHeader('StatusName', false);
        isHiddenHeader('OpenOrderSheetButton', false);
        isHiddenHeader('LinkOrderSheetButton', false);
        isHiddenHeader('ChangeSendingOrderSheetButton', true);
        isHiddenHeader('ReceiptDateType', true);
      };

      isHiddenHeader('OrderType', true);
      isHiddenHeader('Content', false);
      isHiddenHeader('Memo', false);
      isHiddenHeader('Status', true);

      if (EditTypeUtility.getEditTypeInUrl() === EditType.Readonly) {
        caseByReadonly();
      } else {
        caseByEdit();
      }
    };
    /**
     * サブチケットの各カラムの編集状態を設定する
     *
     * @param subTicket 設定対象のサブチケット
     * @param index 行番号
     */
    const setupSubTicket = (subTicket: SubTicketBaseModel, index: number) => {
      let orderType = this.getSubTicketColumnName(subTicket, 'OrderType');
      let content = this.getSubTicketColumnName(subTicket, 'Content');
      let memo = this.getSubTicketColumnName(subTicket, 'Memo');
      let receiptDate = this.getSubTicketColumnName(subTicket, 'ReceiptDate');
      let statusName = this.getSubTicketColumnName(subTicket, 'StatusName');
      let changeSendingOrderSheetButton = this.getSubTicketColumnName(subTicket, 'ChangeSendingOrderSheetButton');
      let receiptDateType = this.getSubTicketColumnName(subTicket, 'ReceiptDateType');
      let openOrderSheetButton = this.getSubTicketColumnName(subTicket, 'OpenOrderSheetButton');
      let linkOrderSheetButton = this.getSubTicketColumnName(subTicket, 'LinkOrderSheetButton');

      /**
       * 編集モードの場合
       */
      const caseByEdit = () => {
        receiptDate.isHidden = true;
        statusName.isHidden = true;
        openOrderSheetButton.isHidden = true;
        linkOrderSheetButton.isHidden = true;

        if (orderType.inputParts.value === 'Master' || orderType.inputParts.value === 'Spot') {
          content.inputParts.setDisabled(true);
          memo.inputParts.setDisabled(true);
          receiptDateType.inputParts.setDisabled(true);

          changeSendingOrderSheetButton.buttonParts.setDisabled(false);
          changeSendingOrderSheetButton.buttonParts.id = `ChangeSendingOrderSheetButton_${index.toString()}`;
          if (subTicket.hiddenKeyValue['StopOrder'] === 'true') {
            changeSendingOrderSheetButton.buttonParts.label = '発注ありに戻す';
            changeSendingOrderSheetButton.buttonParts.class.push('stop-order');
            subTicket.styleClass = ['none-order-row'];
            subTicket.subTicketColumns.forEach((column) => {
              if (column.columnName !== 'OrderType') {
                column.inputParts.setDisabled(true);
              }
            });
          } else {
            changeSendingOrderSheetButton.buttonParts.label = '今回発注なし';
            subTicket.hiddenKeyValue['StopOrder'] = 'false';
            // stop-orderを削除
            changeSendingOrderSheetButton.buttonParts.class = changeSendingOrderSheetButton.buttonParts.class.filter(
              (className: string) => className !== 'stop-order'
            );
            subTicket.styleClass = [];
          }
        } else {
          content.inputParts.setDisabled(false);
          memo.inputParts.setDisabled(false);
          receiptDateType.inputParts.setDisabled(false);

          changeSendingOrderSheetButton.buttonParts.setDisabled(false);
          changeSendingOrderSheetButton.buttonParts.id = `DeleteButton_${index.toString()}`;
          changeSendingOrderSheetButton.buttonParts.label = '削除';
        }
      };

      const caseByReadonly = () => {
        const orderSheetTicketKey = subTicket.hiddenKeyValue['OrderSheetTicketKey'];
        const receiptDateTicketLink = subTicket.hiddenKeyValue['ReceiptDateTicketLink'];

        receiptDateType.isHidden = true;
        changeSendingOrderSheetButton.isHidden = true;

        // ステータス名のclassにステータスの値を設定
        // statusName.inputParts.classAtLabel = ['status-' + status.inputParts.value];
        statusName.inputParts.classAtLabel.push('status-name-label');
        switch (statusName.inputParts.value) {
          case '発注無':
            statusName.inputParts.classAtLabel.push('order-none');
            break;
          case '未発注':
            statusName.inputParts.classAtLabel.push('order-not-finished');
            break;

          case '発注済':
            statusName.inputParts.classAtLabel.push('order-finished');
            break;
        }

        // 発注書を開くボタンの設定
        openOrderSheetButton.buttonParts.setDisabled(false);
        openOrderSheetButton.buttonParts.id = `OpenOrderSheetButton_${index.toString()}`;

        if (ValidateCheckUtility.isEmpty(orderSheetTicketKey)) {
          openOrderSheetButton.buttonParts.isHidden = true;
          // openOrderSheetButton.buttonParts.label = '発注書を作成';
        } else {
          openOrderSheetButton.buttonParts.label = '発注書を開く';
        }

        // 受領日リンクボタンの設定
        linkOrderSheetButton.buttonParts.setDisabled(false);
        linkOrderSheetButton.buttonParts.id = `LinkOrderSheetButton_${index.toString()}`;

        if (ValidateCheckUtility.isEmpty(receiptDateTicketLink)) {
          linkOrderSheetButton.buttonParts.label = '受領日リンク';
          linkOrderSheetButton.buttonParts.class.push('link');
        } else {
          linkOrderSheetButton.buttonParts.label = '受領日リンクを解除';
          linkOrderSheetButton.buttonParts.class.push('remove-link-order-sheet-button');
        }

        if (subTicket.hiddenKeyValue['StopOrder'] === 'true') {
          subTicket.styleClass = ['hide-none-order-row'];
          openOrderSheetButton.buttonParts.isHidden = true;
          linkOrderSheetButton.buttonParts.isHidden = true;
        }
      };

      orderType.isHidden = true;

      if (EditTypeUtility.getEditTypeInUrl() === EditType.Readonly) {
        caseByReadonly();
      } else {
        caseByEdit();
      }
    };

    // ヘッダーカラムの設定
    setupHeaders();

    // 一覧の各カラムの設定
    subTicketListPanel.subTicketList.forEach((subTicket: SubTicketBaseModel, index: number) => {
      setupSubTicket(subTicket, index);
    });
  }

  /**
   * サブチケットのカラムを取得する
   * @param subTicket
   * @param columnName
   * @returns
   */
  getSubTicketColumnName = (subTicket: SubTicketBaseModel, columnName: string) => {
    const column = subTicket.getColumnByColumnName(columnName);
    if (!column) {
      throw new Error(`サブチケットのカラムが見つかりませんでした。columnName:${columnName}`);
    }
    return column;
  };

  /**
   * Programを登録する
   *
   * @description
   * ### 処理の流れ
   * 1. バリデーションチェック
   * 2. 登録データを作成する
   *  - 通常の入力項目の登録データを作成
   *  - サブチケットの登録データを作成
   *    - 受領日の値を作成
   * 3. データ登録処理
   *
   * @remarks
   * 登録データを一部加工するため、独自の登録処理を実装
   *
   * @param panelModels
   * @param service
   */
  registerProgram(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;

    /**
     * 登録データを作成する
     */
    const createRegisterData = () => {
      /**
       * サブチケットの登録データを作成
       * @returns
       */
      const createSubTicketRegisterData = () => {
        let subTicketRequestData: { [key in string]: any[] } = {};
        let responseSubTicketList: any[] = [];
        /**
         * 受領日に登録する値を取得する
         * @param subTicket
         * @returns
         */
        const getReceiptDate = (subTicket: SubTicketBaseModel): string => {
          const orderType = subTicket.getColumnByColumnName('OrderType')?.inputParts.value;
          if (orderType == 'Master' || orderType == 'Spot') {
            return subTicket.getColumnByColumnName('ReceiptDate')?.inputParts.value.toString();
          }

          const onairDate = CastUtility.anyToDateOrNull(subTicket.hiddenKeyValue['OnairDate']);
          if (onairDate == null) {
            throw new Error('放送日が取得できませんでした。');
          }

          let receiptDate: Date | null = null;
          const receiptDateType = subTicket.getColumnByColumnName('ReceiptDateType');
          if (receiptDateType == undefined) {
            throw new Error('受領日タイプが取得できませんでした。');
          }
          const receiptDateTypeRadio = receiptDateType.inputParts as InputRadioAndInputPartsElementModel;

          switch (receiptDateTypeRadio.value) {
            case 'Onairdate':
              receiptDate = onairDate;
              break;

            case 'BeforeOnairdate':
              receiptDate = new Date();
              const prevDay = CastUtility.anyToNumber(receiptDateTypeRadio.getIdAndValue()['CountBeforeOnairdate']);
              receiptDate.setDate(onairDate.getDate() - prevDay);
              break;

            case 'Direct':
              receiptDate = CastUtility.anyToDateOrNull(receiptDateTypeRadio.getIdAndValue()['DirectReceiptDate']);
              break;
          }
          if (receiptDate == null) {
            throw new Error('受領日が取得できませんでした。');
          }
          return CastUtility.getDefaultFormatDay(receiptDate);
        };

        editPanel.subTicketListPanelElementModel.subTicketList.forEach(
          (subTicket: SubTicketBaseModel, index: number) => {
            subTicket.setRowIndex(index);
            let subTicketData = subTicket.getRequestData();

            // 削除データは変更しない
            if (!subTicket.canIncludeRequestData() || subTicket.isDeleteRow()) {
              responseSubTicketList.push(subTicketData);
              return;
            }

            subTicketData['ReceiptDate'] = getReceiptDate(subTicket);
            subTicketData['OnairDate'] = subTicket.hiddenKeyValue['OnairDate'];
            subTicketData['MProgramTicketKey'] = subTicket.hiddenKeyValue['MProgramTicketKey'];
            subTicketData[DbCommonColumnName.ROW_INDEX] = index;
            subTicketData['StopOrder'] = subTicket.hiddenKeyValue['StopOrder'];

            // statusNameを削除
            delete subTicketData['StatusName'];

            responseSubTicketList.push(subTicketData);
          }
        );
        subTicketRequestData[editPanel.subTicketListPanelElementModel.subTicketDataType] = responseSubTicketList;
        return subTicketRequestData;
      };

      let registerData = editPanel.getIdAndValueAsObject();
      registerData[KeyUsedByItem.RESPONSE_DATA_SUB_TICKET_KEY_NAME] = createSubTicketRegisterData();

      // StatusNameを削除
      delete registerData['StatusName'];
      // 表示時に削除した秒を追加
      registerData['OnairDatetime'] = registerData['OnairDatetime'] + ':00';

      return registerData;
    };

    // チェック処理
    if (!this.ValidateAllCheck(editPanel, service)) {
      return;
    }

    // 登録データを取得
    const registerData = createRegisterData();

    /**
     * 自動紐づけ処理
     */
    const autoLink = () => {
      displayLock('処理中');
      const registerData = {
        [DbCommonColumnName.TICKET_TYPE]: editPanel.getTicketKeyObject()[DbCommonColumnName.TICKET_TYPE],
        [DbCommonColumnName.TICKET_KEY]: editPanel.getTicketKeyObject()[DbCommonColumnName.TICKET_KEY],
      };

      let backendServerHookPoint: BackendServerHookPoint = new BackendServerHookPoint();
      backendServerHookPoint.overrideExecuteFunctionName = 'ProgramAndOrdersheetLinkByProgram';

      const callBackByAutoLink = (responseData: ResponseDataModel) => {
        displayUnLock();
        if (!responseData.isCompleted) {
          responseData.errorMessageList.push('受領日の紐づけに失敗しました。');
        }
        service.moveViewService.moveViewInGocooEngine(ViewType.Edit, 'Program', EditType.Readonly, {
          TicketKey: editPanel.commonDBValue.ticketKey,
          TicketType: editPanel.commonDBValue.ticketType,
        });
      };

      service.dataTransmissionService.registerRecord(
        ViewType.Edit,
        editPanel.getTicketKeyObject()[DbCommonColumnName.TICKET_TYPE],
        registerData,
        callBackByAutoLink,
        backendServerHookPoint,
        false
      );
    };

    const callBack = (responseData: ResponseDataModel) => {
      if (!responseData.isCompleted) {
        return;
      }

      // 受領日の紐づけ処理
      autoLink();
    };
    // データ登録処理
    service.dataTransmissionService.registerRecord(ViewType.Edit, 'Program', registerData, callBack, null, true);
  }

  /**
   * 発注データ再作成ボタンの押下時の処理
   * @param panelModels
   * @param service
   */
  recreateProgramOrder(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    const callBack = () => {
      displayUnLock();
      service.moveViewService.changeEditType(EditType.Readonly);
    };
    service.dialogService.showYesOrNoConfirmDialog('発注データを再作成します\nよろしいですか').then((result) => {
      if (result !== ConfirmResult.Yes) {
        return;
      }
      displayLock('処理中');
      let backendServerHookPoint: BackendServerHookPoint = new BackendServerHookPoint();
      backendServerHookPoint.overrideExecuteFunctionName = 'RecreateProgramOrder';

      const data = {
        [DbCommonColumnName.TICKET_KEY]: editPanel.getTicketKeyObject()[DbCommonColumnName.TICKET_KEY],
      };
      const request = Object.assign(editPanel.commonDBValue.getKeyValueForEditPanel(), data);

      service.dataTransmissionService.registerRecord(
        ViewType.ConditionList,
        editPanel.commonDBValue.ticketType,
        request,
        callBack,
        backendServerHookPoint,
        false
      );
    });
  }

  /**
   * 発注データ再作成ボタンの押下時の処理
   * @param panelModels
   * @param service
   */
  moveMProgramPage(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    const programData = editPanel.getIdAndValueAsObject();
    if (!programData['MProgramTicketKey']) {
      throw '番組マスタチケットキーがありません。';
    }
    service.moveViewService.moveViewInGocooEngine(ViewType.Edit, 'MProgram', EditType.Readonly, {
      TicketKey: programData['MProgramTicketKey'],
    });
  }

  /**
   * 各放送回ごとの発注でデータを削除
   * @param panelModels
   * @param service
   * @param rowIndex
   * @returns
   */
  deleteOnetimeData = (
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack,
    rowIndex: number
  ) => {
    const editPanel = panelModels.get(PanelType.EditPanel) as EditPanelElementModel;
    const subTicket = editPanel.subTicketListPanelElementModel.subTicketList[rowIndex];

    const orderType = subTicket.getColumnByColumnName('OrderType');
    if (orderType == undefined) {
      return;
    }

    // 削除可能かチェック
    if (orderType.inputParts.value !== 'Onetime') {
      service.dialogService.showOkOnlyConfirmDialog('マスター発注のため、削除できません。').then(() => {
        return;
      });
      return;
    }

    subTicket.deleteSubTicket();
  };
  /**
   * 入力項目の全体的なチェック処理
   * @param editPanel
   * @param service
   * @returns
   */
  ValidateAllCheck = (editPanel: EditPanelElementModel, service: DevelopScriptServicePack) => {
    // メッセージをクリア
    service.messageService.clearMessage();

    let result = true;

    // 通常の入力項目
    if (!editPanel.checkValidateAllInputParts()) {
      service.messageService.addMessage('入力エラーがあります。', MessageType.Error);
      result = false;
    }

    // サブチケット
    editPanel.subTicketListPanelElementModel.subTicketList.forEach((subTicket: SubTicketBaseModel, index: number) => {
      if (subTicket.isDeleteRow()) {
        return;
      }
      subTicket.subTicketColumns.forEach((subTicketColumn) => {
        if (subTicketColumn.isHidden || subTicketColumn.inputParts.disabled) {
          return;
        }
        if (!subTicketColumn.inputParts.checkValidate()) {
          service.messageService.addMessage(
            `発注リスト${index}行目 ${subTicketColumn.inputParts.errMsg}`,
            MessageType.Error
          );
          result = false;
        }
      });
    });
    return result;
  };

  /**
   * 発行状況のスタイルを設定する
   * @param editPanel
   */
  setupStatusNameStyle = (editPanel: EditPanelElementModel) => {
    editPanel.inputPartsList.forEach((inputParts: InputPartsBaseModel) => {
      if (inputParts.id.includes('StatusName')) {
        switch (inputParts.value) {
          case '発注無':
            inputParts.classAtLabel.push('order-none');
            break;
          case '未発注':
            inputParts.classAtLabel.push('order-not-finished');
            break;

          case '発注済':
            inputParts.classAtLabel.push('order-finished');
            break;
        }
      }
    });
  };

  /**
   * 放送日時から末尾の秒を削除する
   * @param editPanel
   */
  setupHideSecForOnairDatetime = (editPanel: EditPanelElementModel) => {
    editPanel.inputPartsList.forEach((inputParts: InputPartsBaseModel) => {
      if (inputParts.id.includes('OnairDatetime')) {
        inputParts.value = inputParts.value.replace(/:00$/, '');
      }
    });
  };

  /**
   * 編集ボタンの表示設定を行う
   * @param editPanel
   * @param service
   * @returns
   */
  setupShowEditButton = async (editPanel: EditPanelElementModel, service: DevelopScriptServicePack) => {
    const canEdit = await this.canEdit(editPanel, service);
    if (canEdit) {
      return;
    }

    if (editPanel.editType === EditType.Edit) {
      service.dialogService
        .showOkOnlyConfirmDialog(
          '現在のユーザーでは\n指定した編集モードで画面を表示することはできません。\n読み取り専用に遷移します。'
        )
        .then(() => {
          service.moveViewService.changeEditType(EditType.Readonly);
        });
    }

    service.moveEditTypeButtonService.hiddenEditButton();
  };

  /**
   * 編集可能か判定する
   * @param editPanel
   * @param service
   * @returns true: 編集可能 false: 編集不可
   */
  canEdit = async (editPanel: EditPanelElementModel, service: DevelopScriptServicePack) => {
    // パラメータチェック
    if (ValidateCheckUtility.isEmpty(editPanel.commonDBValue.ticketKey)) {
      await service.dialogService.showOkOnlyConfirmDialog('パラメータに異常がありました。\nタイムテーブルに戻ります。');

      service.moveViewService.moveViewInGocooEngine(ViewType.WeekTimeTable, 'Program', EditType.Readonly, {});
      return;
    }

    let mProgramTicketKey = '';
    editPanel.inputPartsList.forEach((inputParts: InputPartsBaseModel) => {
      if (inputParts.id === 'MProgramTicketKey') {
        mProgramTicketKey = inputParts.value;
      }
    });

    // 編集可能か判定 (紐づくMProgramの編集権限を持っているか)
    return await MProgramUtility.canEditProgramByLoginUser(mProgramTicketKey);
  };
}
